import { isNative } from "@/lib/native";

export async function initNativeShell() {
  if (!isNative) return;
  document.documentElement.classList.add("native-app");
  try {
    await setupPlugins();
  } catch { /* plugin unavailable */ }
}

async function setupPlugins() {
  const [{ App }, { SplashScreen }, { StatusBar, Style }] = await Promise.all([
    import("@capacitor/app"), import("@capacitor/splash-screen"), import("@capacitor/status-bar"),
  ]);
  try { await StatusBar.setStyle({ style: Style.Light }); } catch { /* iOS only */ }
  window.setTimeout(() => SplashScreen.hide().catch(() => {}), 400);
  await App.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack) window.history.back();
    else App.exitApp();
  });
  await App.addListener("appUrlOpen", ({ url }) => {
    try {
      const { pathname, search } = new URL(url);
      window.history.pushState({}, "", pathname + search);
      window.dispatchEvent(new PopStateEvent("popstate"));
    } catch { /* ignore */ }
  });
}
